import { useState } from "react"
import { PropTypes } from "prop-types"
import classNames from "classnames"

import Translate from "../../Translate"
import Field from "../Field"
import InputTextArea from "./InputTextArea"
import fieldSchemaPropTypes from "../fieldSchemaPropTypes"
import errorPropTypes from "../errorPropTypes"

export function TextAreaField(props) {
  const {
    className,
    error,
    id,
    label,
    labelId,
    name,
    schema,
    value,
    onChange,
    touched = false,
    ...rest
  } = props
  const { maxLength } = schema
  const initialRemainingValue = value ? maxLength - value.length : maxLength
  const [remaining, setRemaining] = useState(initialRemainingValue)

  const handleChange = e => {
    const newValue = e.target.value
    setRemaining(maxLength - newValue.length)
    onChange(name, newValue)
  }

  return (
    <div className={classNames("oj-text-area-field", className)}>
      <Field error={error} {...schema} touched={touched} {...rest}>
        <Field.Label id={labelId} inputId={id} label={label} required={schema.required}>
          <Field.Input {...schema} {...rest} id={id} error={error} name={name} value={value}>
            {innerProps => (
              <>
                <InputTextArea {...innerProps} onChange={handleChange} />
                <div className="input-maxlength-notice">
                  <Translate id="textAreaMaxCharacters" data={{ remaining }} />
                </div>
              </>
            )}
          </Field.Input>
        </Field.Label>
      </Field>
    </div>
  )
}

TextAreaField.propTypes = {
  className: PropTypes.string,
  error: PropTypes.shape(errorPropTypes),
  id: PropTypes.string,
  label: PropTypes.node,
  labelId: PropTypes.string,
  name: PropTypes.string.isRequired,
  schema: PropTypes.shape(fieldSchemaPropTypes),
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  touched: PropTypes.bool
}

export default TextAreaField
